module.exports = __webpack_public_path__ + "static/img/shrb.176b398.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shrb.jpg
// module id = lIsM
// module chunks = 0